import { ITermsData, TermsData } from '../../codegen/fetchTerms';

export const getTermsVersionString = (terms: TermsData | ITermsData) => {
  const { general_terms_version, data_retention_version } = terms;

  let versionString = '';
  if (general_terms_version) {
    versionString += `generalTermsVersion: ${general_terms_version};`;
  }
  if (data_retention_version) {
    versionString += `dataRetentionVersion: ${data_retention_version};`;
  }

  return versionString;
};
